<template>
  <b-modal
    id="customIdModal"
    v-model="show"
    @ok="onConfirm"
  >
    <template v-slot:default>
      <b-col>
        <label for="config-CustomId">Custom ID:</label>
      </b-col>
      <b-col>
        <b-form-input
          id="config-CustomId"
          v-model.trim="customId"
          size="sm"
          type="text"
        />
      </b-col>
    </template>

    <template v-slot:modal-footer>
      <b-col class="mr-2">
        <b-button
          variant="success"
          @click="onCancel"
        >
          Use default
        </b-button>
        <b-button
          :disabled="!allowSave"
          @click="onConfirm"
        >
          Save custom ID
        </b-button>
      </b-col>
    </template>
  </b-modal>
</template>
<script>
export default {
  name: 'ConfigurationCustomId',
  props: {
    enabled: Boolean
  },
  data() {
    return {
      customId: '',
      show: this.enabled
    }
  },
  computed: {
    allowSave() {
      return Boolean(this.customId)
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.customId)
      this.show = false
    },
    onCancel() {
      this.show = false
    }
  }
}
</script>
